import { LocationStrategy } from '@angular/common';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IBaseModel } from '../models/base.model';
import { PaginacaoModel } from '../models/paginacao.model';
import { IRiscosChavesModel, IRiscosChavesProcessoItemModel } from '../models/riscos-chaves.model';
import { FiltroModel } from '../models/filtro.model';
import { BaseService } from './base.service';
import { filterBy } from '../core/helpers/filterby';
import { IRiscosChavesListaModel } from '../models/riscos-chaves-lista.model';
import { FiltroQuestionarioUG } from '../models/filtro-questionario-ug.model';
import { IImprimirQuestionarioRespostaUGModel, IListaQuestionarioRespostaUGModel, IQuestionarioUGModel, IVisualizarQuestionarioRespostaUGModel } from '../models/questionario-ug.model';
import { IArquivoModel } from '../models/arquivo.model';
import { FiltroRiscosChavesModel } from "../models/filtro-riscos-chaves.model";
import { IRiscosChavesProcesso } from '../models/riscos-chaves-processo ';

@Injectable({
  providedIn: 'root',
})
export class RiscosChavesServices extends BaseService {

  constructor(httpClient: HttpClient, locationStrategy: LocationStrategy) {
    super(httpClient, locationStrategy);
  }

  public obter(filtro: FiltroRiscosChavesModel): Promise<IBaseModel<PaginacaoModel<IRiscosChavesListaModel[]>>> {
    return this.httpClient
      .get<IBaseModel<PaginacaoModel<IRiscosChavesListaModel[]>>>(filterBy(filtro, `${this.apiBaseUrl}/RiscosChaves`))
      .toPromise();
  }
  public async solicitarPreenchimentoFormulario(id: number, qtdeDiasPrazo: number): Promise<IBaseModel<void>> {
    return this.httpClient
      .post<IBaseModel<void>>(`${this.apiBaseUrl}/RiscosChaves/${id}/${qtdeDiasPrazo}/solicitarPreenchimento`, {})
      .toPromise();
  }

  public async Avocar(id: number): Promise<IBaseModel<void>> {
    return this.httpClient
      .post<IBaseModel<void>>(`${this.apiBaseUrl}/RiscosChaves/${id}/avocar`, {})
      .toPromise();
  }

  public obterItensProcesso(riscoChaveId: number, processoId: number):
    Promise<IBaseModel<IRiscosChavesProcessoItemModel[]>> {
    const url = `${this.apiBaseUrl}/riscosChaves/${riscoChaveId}/${processoId}`;
    return this.httpClient
      .get<IBaseModel<IRiscosChavesProcessoItemModel[]>>(url)

      .toPromise();

  }

  public obterProcesso(riscoChaveId: number): Promise<IBaseModel<IRiscosChavesProcesso[]>> {
    const url = `${this.apiBaseUrl}/riscosChaves/obterProcessos/${riscoChaveId}`;
    return this.httpClient.get<IBaseModel<IRiscosChavesProcesso[]>>(url).toPromise();
  }

  public async obterPorId(id: number): Promise<IBaseModel<IRiscosChavesModel>> {
    return this.httpClient
      .get<IBaseModel<IRiscosChavesModel>>(`${this.apiBaseUrl}/RiscosChaves/${id}`)
      .toPromise();
  }

  public async inserir(
    data: IRiscosChavesModel
  ): Promise<IBaseModel<IRiscosChavesModel>> {
    return this.httpClient
      .post<IBaseModel<IRiscosChavesModel>>(`${this.apiBaseUrl}/riscosChaves`, data)
      .toPromise();
  }

  public async inserirProcessoItem(
    data: IRiscosChavesProcessoItemModel
  ): Promise<IBaseModel<IRiscosChavesProcessoItemModel>> {
    return this.httpClient
      .post<IBaseModel<IRiscosChavesProcessoItemModel>>(`${this.apiBaseUrl}/riscosChaves/InserirProcessoItem`, data)
      .toPromise();
  }

  public async enviarArquivo(idUG: number, idTipoUniversoAuditavel: number, criterioAvaliacaoId: number, anexo: IArquivoModel): Promise<IBaseModel<void>> {
    const formData: FormData = new FormData();

    formData.append('id', anexo.id.toString());
    formData.append('nomeArquivo', anexo.nomeArquivo);
    formData.append('entidadeArquivo', anexo.entidadeArquivo.toString());
    formData.append('arquivo', anexo.arquivo);

    return this.httpClient
      .post<IBaseModel<void>>(`${this.apiBaseUrl}/RiscosChaves/${idUG}/${idTipoUniversoAuditavel}/${criterioAvaliacaoId}/enviarArquivo`, formData, {})
      .toPromise();
  }

  public async DownloadArquivo(idUG: number, idTipoUniversoAuditavel: number): Promise<IBaseModel<IArquivoModel>> {
    return this.httpClient
      .post<IBaseModel<IArquivoModel>>(`${this.apiBaseUrl}/RiscosChaves/${idUG}/${idTipoUniversoAuditavel}/obterArquivo`, {})
      .toPromise();
  }

  public async encerrarRiscoImportacaoArquivo(idUG: number, idTipoUniversoAuditavel: number): Promise<IBaseModel<boolean>> {
    return this.httpClient
      .post<IBaseModel<boolean>>(`${this.apiBaseUrl}/RiscosChaves/${idUG}/${idTipoUniversoAuditavel}/encerrar-avaliacao-arquivo-importado`, null, {})
      .toPromise();
  }


  public async atualizar(data: IRiscosChavesModel): Promise<IBaseModel<void>> {
    return this.httpClient
      .put<IBaseModel<void>>(`${this.apiBaseUrl}/RiscosChaves/${data.id}`, data)
      .toPromise();
  }

  public async excluir(id: number): Promise<IBaseModel<void>> {
    return this.httpClient
      .delete<IBaseModel<void>>(`${this.apiBaseUrl}/RiscosChaves/excluir/${id}`, {})
      .toPromise();
  }

  public async atualizarProcesso(data: IRiscosChavesProcessoItemModel): Promise<IBaseModel<void>> {
    return this.httpClient
      .put<IBaseModel<void>>(`${this.apiBaseUrl}/RiscosChaves/AtualizarProcesso`, data)
      .toPromise();
  }


  public async excluirProcesso(id: number): Promise<IBaseModel<void>> {
    return this.httpClient
      .delete<IBaseModel<void>>(`${this.apiBaseUrl}/RiscosChaves/excluirProcesso/${id}`, {})
      .toPromise();
  }

  public finalizarRiscosChaves(
    id: number
  ): Promise<IBaseModel<any>> {
    return this.httpClient
      .put<IBaseModel<boolean>>(
        `${this.apiBaseUrl}/RiscosChaves/${id}/finaliza-resposta-risco-chaves`,
        {}
      )
      .toPromise();
  }

  public DelegarQuestionario(questionarioItemsId: string, idResponsavel: string, idRiscoChave : any): Promise<IBaseModel<any>> {
    return this.httpClient.put<IBaseModel<boolean>>(`${this.apiBaseUrl}/RiscosChaves/questionario/${questionarioItemsId}/responsavel/${idResponsavel}/riscoChave/${idRiscoChave}`, {})
      .toPromise();
  }

  public FinalizarQuestionario(questionarioItemsId: string, idRiscoChave : any): Promise<IBaseModel<any>> {
    return this.httpClient.put<IBaseModel<boolean>>(`${this.apiBaseUrl}/RiscosChaves/finalizarQuestionario/${questionarioItemsId}/riscoChave/${idRiscoChave}`, {}).toPromise();
  }

  public EnviarQuestionario(idRiscoChave : any): Promise<IBaseModel<any>> {
    return this.httpClient.put<IBaseModel<boolean>>(`${this.apiBaseUrl}/RiscosChaves/enviar/riscoChave/${idRiscoChave}`, {}).toPromise();
  }

  public SalvarQuestionario(idRiscoChave : any): Promise<IBaseModel<any>> {
    return this.httpClient.put<IBaseModel<boolean>>(`${this.apiBaseUrl}/RiscosChaves/salvar/riscoChave/${idRiscoChave}`, {}).toPromise();
  }
}
